<div id="maintenance">
  <img src="./assets/images/psl-logo-white.svg" alt="Powerside" class="logo" />
  <h1 class="maintenance-footer">{{ 'tempMaintenance.title' | translate }}</h1>
  <div class="maintenance-footer">
    {{ 'global.footer' | translate }}
  </div>
</div>
